
import request from '../index.js';

// 桥梁列表
export const bridgeList = (query) => {
  return request({
      url: '/iotBride/getIotBrideList',
      method: 'POST',
      data: query
  })
}
// 删除桥梁
export const delbridge = (query) => {
  return request({
      url: '/iotBride/deleteIotBrideById',
      method: 'DELETE',
      params: query
  })
}
// 添加桥梁
export const addbridge = (query) => {
  return request({
      url: '/iotBride/addIotBride',
      method: 'POST',
      data: query
  })
}
// 修改桥梁
export const alterbridge = (query) => {
  return request({
      url: '/iotBride/updateIotBride',
      method: 'PUT',
      data: query
  })
}
// 线路列表
export const lineList = (query) => {
  return request({
      url: '/iotLine/getIotLineList',
      method: 'POST',
      data: query
  })
}
// 删除线路
export const delLine = (query) => {
  return request({
      url: '/iotLine/deleteIotLineById',
      method: 'DELETE',
      params: query
  })
}
// 添加线路
export const addLine = (query) => {
  return request({
      url: '/iotLine/addLine',
      method: 'POST',
      data: query
  })
}
// 修改线路
export const alterLine = (query) => {
  return request({
      url: '/iotLine/updateIotLine',
      method: 'PUT',
      data: query
  })
}
// 获取线路坐标点
export const getPoi = (query) => {
  return request({
      url: '/iotLine/getCoordinateString',
      method: 'POST',
      data: query
  })
}
// 设备列表
export const deviceList = (query) => {
  return request({
      url: '/iotDevice/getIotDeviceList',
      method: 'POST',
      data: query
  })
}
// 删除设备
export const delDevice = (query) => {
  return request({
      url: '/iotDevice/deleteIotDeviceById',
      method: 'DELETE',
      params: query
  })
}
// 添加设备
export const addDevice = (query) => {
  return request({
      url: '/iotDevice/addIotDevice',
      method: 'POST',
      data: query
  })
}
//选择设备
export const getDevice = (query) => {
  return request({
      url: '/iotApiDevice/getIotAipDevice',
      method: 'GET',
      params: query
  })
}
//获取站外设备
export const getDeviceOutside = (query) => {
  return request({
      url: '/iotDevice/getSiteOutside',
      method: 'POST',
      data: query
  })
}
// 修改设备
export const alterDevice = (query) => {
  return request({
      url: '/iotDevice/updateDevice',
      method: 'PUT',
      data: query
  })
}
// 设备生成二维码
export const createCode = (query) => {
  return request({
      url: '/iotDevice/createQRCode',
      method: 'GET',
      params: query
  })
}
// 获取设备状态统计
export const deviceStatus = (query) => {
  return request({
      url: '/iotDevice/getDeviceStatus',
      method: 'GET',
      params: query
  })
}
// 产品列表
export const productList = (query) => {
  return request({
      url: '/iotProductManage/getIotProductList',
      method: 'POST',
      data: query
  })
}
// 添加产品
export const addProduct = (query) => {
  return request({
      url: '/iotProductManage/addIotProduct',
      method: 'POST',
      data: query
  })
}
// 修改产品
export const alterProduct = (query) => {
  return request({
      url: '/iotProductManage/updateProduct',
      method: 'PUT',
      data: query
  })
}
// 删除产品
export const delProduct = (query) => {
  return request({
      url: '/iotProductManage/deleteProduct',
      method: 'DELETE',
      data: query
  })
}
// 文件上传
export const upload = (query) => {
  return request({
      url: '/file/upload',
      method: 'POST',
      data: query
  })
}